/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
import { toast } from 'react-toastify';
import _ from 'lodash';
import axios from 'axios';
import api from '../services/api';
import {
  normalizeDocumentForPayload,
  validateDocument as validateDocumentValue,
} from './document';

const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
const customerCode = localStorage.getItem('@UltragazEmpresarial:customerCode');
const customerSiteCode = localStorage.getItem(
  '@UltragazEmpresarial:customerSiteCode'
);

export const unsecuredCopyToClipboard = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    document.execCommand('copy');
  } catch (err) {
    toast.error('Unable to copy to clipboard');
  }
  document.body.removeChild(textArea);
};

export const newToken = () => {
  const req = axios.create({
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': 'pt-BR',
      client_id: process.env.REACT_APP_CLIENT_ID,
    },
    baseURL: process.env.REACT_APP_API_URL_OAUTH,
  });

  const header = {
    'Content-Type': 'application/json',
  };
  const parameters = {
    method: 'POST',
    headers: header,
    auth: {
      username: '16aa22fe-4aef-3900-b559-642745e09178',
      password: 'd24168f6-0b1e-35a3-b607-5c305e7b19f3',
    },
  };
  const body = {
    grant_type: 'client_credentials',
  };
  req
    .post('oauth/access-token', body, parameters)
    .then((res) => {
      const response = res.data;
      if (res.status === 201) {
        localStorage.setItem(
          '@UltragazEmpresarial:accessToken',
          response.access_token
        );
      }
    })
    .catch((err) => {});
};

export const getUserData = async () => {
  const header = {
    'Content-Type': 'application/json',
    access_token: token,
  };
  const parameters = {
    method: 'GET',
    headers: header,
  };

  try {
    const res = await api.get(
      'industrial/customer/v1/customers/me',
      parameters
    );
    if (res.data) {
      return res.data;
    }
  } catch (err) {
    console.error(err);
  }
};

const removeAllItemsLocalStorage = () => {
  localStorage.removeItem('@UltragazEmpresarial:closeReclameAqui');
  localStorage.removeItem('@UltragazEmpresarial:closeBannerPromotion');
  localStorage.removeItem('@UltragazEmpresarial:closeModalBestTimes');
  localStorage.removeItem('@UltragazEmpresarial:closeBannerNPS');
  localStorage.removeItem('@UltragazEmpresarial:closeBannerAvisoMFA');
  localStorage.removeItem('@UltragazEmpresarial:closeBannerAvisoPIX');
  localStorage.removeItem('@UltragazEmpresarial:closeBannerNewRefuel');
  localStorage.removeItem(
    '@UltragazEmpresarial:closeBannerPesquisaUsabilidade'
  );
  localStorage.removeItem('@UltragazEmpresarial:closeAlertAbasteciment');
  localStorage.removeItem('@UltragazEmpresarial:closeBannerIncidenteRs');
  localStorage.removeItem('@UltragazEmpresarial:customerCode');
  localStorage.removeItem('@UltragazEmpresarial:customerSiteId');
  localStorage.removeItem('@UltragazEmpresarial:customerName');
  localStorage.removeItem('@UltragazEmpresarial:refreshToken');
  localStorage.removeItem('@UltragazEmpresarial:accessToken');
  localStorage.removeItem('@UltragazEmpresarial:userName');
  localStorage.removeItem('@UltragazEmpresarial:document');
  localStorage.removeItem('@UltragazEmpresarial:customerId');
  localStorage.removeItem('@UltragazEmpresarial:customerSiteCode');
  localStorage.removeItem('@UltragazEmpresarial:loginEmail');
  localStorage.removeItem('@UltragazEmpresarial:customerAddressLine');
  localStorage.removeItem('@UltragazEmpresarial:userCustomerRelationshipId');
  localStorage.removeItem('@UltragazEmpresarial:customerType');
  localStorage.removeItem('@UltragazEmpresarial:loginChatBot');
  localStorage.removeItem('twilio-flex-cf');
  localStorage.removeItem('loglevel:twilio-flex-webchat-ui');
};

export const signOut = () => {
  removeAllItemsLocalStorage();
  sessionStorage.clear();
  window.location.href = '/';
};

export const verifyUser = (props) => {
  if (token === null) {
    removeAllItemsLocalStorage();
    const { history } = props;
    history.push('/acessar');
  }
};

export const formatMoney = (
  amount,
  decimalCount = 2,
  decimal = '.',
  thousands = ','
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  } catch (e) {
    console.error(e);
  }
};

export function isObjectEmpty(object) {
  if (JSON.stringify(object) == JSON.stringify({})) {
    return true;
  }
  return false;

  return false;
}

export const arrUniqueContact = (arr) => {
  const cleaned = [];
  arr.forEach(function (itm) {
    let unique = true;
    cleaned.forEach(function (itm2) {
      if (_.isEqual(itm?.contact, itm2?.contact)) unique = false;
    });
    if (unique) cleaned.push(itm);
  });
  return cleaned;
};

export const arrUniqueContactMFA = (arr) => {
  const cleaned = [];
  console.log({ arr });
  arr.forEach(function (itm) {
    console.log({ itm });
    let unique = true;
    cleaned.forEach(function (itm2) {
      console.log({ itm2 });
      if (_.isEqual(itm.contact, itm2.contact)) unique = false;
    });
    if (unique) cleaned.push(itm);
  });
  return cleaned;
};

export const validateCPF = (strCPF) => {
  let retSum = 0;
  let restOfDivision;
  const exp = /\.|-|\//g;
  let newCpf = strCPF;
  newCpf = newCpf.toString().replace(exp, '');

  if (newCpf === '') return false;
  if (newCpf === '00000000000') return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    newCpf === '00000000000' ||
    newCpf === '11111111111' ||
    newCpf === '22222222222' ||
    newCpf === '33333333333' ||
    newCpf === '44444444444' ||
    newCpf === '55555555555' ||
    newCpf === '66666666666' ||
    newCpf === '77777777777' ||
    newCpf === '88888888888' ||
    newCpf === '99999999999'
  )
    return false;

  for (let i = 1; i <= 9; i += 1) {
    retSum += Number(newCpf.substring(i - 1, i)) * (11 - i);
  }
  restOfDivision = (retSum * 10) % 11;

  if (restOfDivision === 10 || restOfDivision === 11) restOfDivision = 0;
  if (restOfDivision !== Number(newCpf.substring(9, 10))) return false;

  retSum = 0;
  for (let i = 1; i <= 10; i += 1) {
    retSum += Number(newCpf.substring(i - 1, i)) * (12 - i);
  }
  restOfDivision = (retSum * 10) % 11;

  if (restOfDivision === 10 || restOfDivision === 11) restOfDivision = 0;
  if (restOfDivision !== Number(newCpf.substring(10, 11))) return false;
  return true;
};

export const validateCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj === '') return false;

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999'
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i -= 1) {
    soma += numeros.charAt(tamanho - i) * pos;
    pos -= 1;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado.toString() !== digitos.charAt(0)) return false;

  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i -= 1) {
    soma += numeros.charAt(tamanho - i) * pos;
    pos -= 1;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado.toString() !== digitos.charAt(1)) return false;

  return true;
};

export const validateDocument = (value) => {
  return validateDocumentValue(value);
};

export const phoneMask = (v) => {
  v = v.replace(/\D/g, '');
  v = v.replace(/^(\d{2})(\d)/g, '($1) $2');
  v = v.replace(/(\d)(\d{4})$/, '$1-$2');
  return v;
};

export const calcularForcaDeSenha = (senha) => {
  const maicusculas = /[A-Z]/;
  const minusculas = /[a-z]/;
  const numeros = /[0-9]/;
  const especiais = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
  // const lowCaseSeq =
  //   /^(?!.*abc|.*bcd|.*cde|.*def|.*efg|.*fgh|.*ghi|.*hij|.*ijk|.*jkl|.*klm|.*lmn|.*mno|.*nop|.*opq|.*pqr|.*qrs|.*rst|.*stu|.*tuv|.*uvw|.*vwx|.*wxy|.*xyz|.*aaa|.*bbb|.*ccc|.*ddd|.*eee|.*fff|.*ggg|.*hhh|.*iii|.*jjj|.*kkk|.*lll|.*mmm|.*nnn|.*ooo|.*ppp|.*rrr|.*sss|.*ttt|.*uuu|.*vvv|.*www|.*xxx|.*yyy|.*zzz).*$/;
  // const upperCaseSeq =
  //   /^(?!.*ABC|.*BCD|.*CDE|.*DEF|.*EFG|.*FGH|.*GHI|.*HIJ|.*IJK|.*JKL|.*KLM|.*LMN|.*MNO|.*NOP|.*OPQ|.*PQR|.*QRS|.*RST|.*STU|.*TUV|.*UVW|.*VWX|.*WXY|.*XYZ|.*AAA|.*BBB|.*CCC|.*DDD|.*EEE|.*FFF|.*GGG|.*HHH|.*III|.*JJJ|.*KKK|.*LLL|.*MMM|.*NNN|.*OOO|.*PPP|.*RRR|.*SSS|.*TTT|.*UUU|.*VVV|.*WWW|.*XXX|.*YYY|.*ZZZ).*$/;
  // const numerosSeq =
  //   /^(?!.*012|.*123|.*234|.*345|.*456|.*567|.*678|.*789|.*000|.*111|.*222|.*333|.*444|.*555|.*666|.*777|.*888|.*999).*$/;

  const senhaValidada = {
    maiusculasOK: false,
    minusculasOK: false,
    numerosOK: false,
    especiaisOK: false,
    lowCaseSeqOK: false,
    upperCaseSeqOK: false,
    numerosSeqOK: false,
    tamanhoMinOK: senha.length >= 8,
  };

  if (senha.match(maicusculas)) senhaValidada.maiusculasOK = true;
  if (senha.match(minusculas)) senhaValidada.minusculasOK = true;
  if (senha.match(numeros)) senhaValidada.numerosOK = true;
  if (senha.match(especiais)) senhaValidada.especiaisOK = true;
  // if (senha.match(lowCaseSeq)) senhaValidada.lowCaseSeqOK = true;
  // if (senha.match(upperCaseSeq)) senhaValidada.upperCaseSeqOK = true;
  // if (senha.match(numerosSeq)) senhaValidada.numerosSeqOK = true;

  return senhaValidada;
};

export const cleanCPFAndCNPJ = (value) => {
  return normalizeDocumentForPayload(value);
};

export const cleanPhone = (value) => {
  value = value.replace('-', '');
  value = value.replace('-', '');
  value = value.replace('(', '');
  value = value.replace(')', '');
  value = value.replace(' ', '');

  return value;
};

export const makeRangeArray = (value) => {
  if (!value) return [0, 10, 20, 30, 40, 50, 60, 70];
  const qtdZero = String(value).length - 1;
  let divisor = 10;
  if (qtdZero === 1) {
    divisor = 10;
  } else if (qtdZero === 2) {
    divisor = 100;
  } else if (qtdZero === 3) {
    divisor = 1000;
  } else if (qtdZero === 4) {
    divisor = 10000;
  } else if (qtdZero === 5) {
    divisor = 100000;
  } else if (qtdZero === 6) {
    divisor = 1000000;
  }

  const maxNumberAredonded = Math.ceil(value / divisor) * divisor;

  const rangeValue = maxNumberAredonded / 5;
  const range = [0];

  let addValue = 0;
  for (let i = 6; i >= 0; i -= 1) {
    const numberPush = rangeValue + addValue;
    range.push(numberPush);
    addValue += rangeValue;
    if (numberPush > value) {
      break;
    }
  }

  return range;
};

export const translateMonthAndYear = (
  data,
  dataType = 'month',
  isMobile = false
) => {
  const months = [
    {
      key: '01',
      value: 'Jan',
    },
    {
      key: '02',
      value: 'Fev',
    },
    {
      key: '03',
      value: 'Mar',
    },
    {
      key: '04',
      value: 'Abr',
    },
    {
      key: '05',
      value: 'Mai',
    },
    {
      key: '06',
      value: 'Jun',
    },
    {
      key: '07',
      value: 'Jul',
    },
    {
      key: '08',
      value: 'Ago',
    },
    {
      key: '09',
      value: 'Set',
    },
    {
      key: '10',
      value: 'Out',
    },
    {
      key: '11',
      value: 'Nov',
    },
    {
      key: '12',
      value: 'Dez',
    },
  ];
  const dataArray = data.split('-');
  const year = isMobile
    ? dataArray[0].substring(dataArray[0].length - 2)
    : dataArray[0];
  const [monthLiteral] = months.filter((month) => month.key === dataArray[1]);
  if (dataType === 'day') {
    return `${dataArray[2]}/${monthLiteral.value}/${year}`;
  }
  if (dataType === 'month') {
    return `${monthLiteral.value}/${year}`;
  }
  return data;
};
